export default {
  required (name) {
    return (rule, value, callback) => {
      if (value === undefined || value === null || value.length === 0) {
        callback(new Error(`${name || '该项'}不能为空`))
      }
      callback()
    }
  }
}
